const momentFormat = {
  DATE: 'ddd, MMM D YYYY',
  DATE_TIME: 'ddd, MMM D YYYY [at] HH:mm',
  API: 'YYYY-MM-DD[T]HH:mm:ss'
};

const message = {
  CONTENT_WARNING: 'Your company will still be charged if booking is not Approved',
  NO_POLICY_BREAK: 'Within Policy'
};

const api = {
  root: `${window.apiUrl}`,
  url: `${window.apiUrl}api/`,
  sctApiUrl: `${window.sctApiUrl}api/`,
  iataSct: `${window.apiUrl}api/Itinerary/IataSearchSct`,
  citySearch: `${window.apiUrl}api/Location/city`,
  depotSearch: `${window.apiUrl}api/Car/depots`,
  car: `${window.apiUrl}api/car`,
  carDetails: `${window.apiUrl}api/car/detail`,
  hotels: `${window.apiUrl}api/hotel`,
  hotelPartial: `${window.apiUrl}api/HotelPartial`,
  hotelRates: `${window.apiUrl}api/hotel/rates`,
  hotelReviews: `${window.apiUrl}api/hotel/reviews`,
  hotelPolicy: `${window.apiUrl}api/Hotel/CheckPolicy`,
  token: `${window.apiUrl}Token`,
  flail: `${window.apiUrl}api/Rail/`,
  supplierLocations: `${window.apiUrl}api/supplierLocations/`,
  poi: `${window.apiUrl}api/PointOfInterest`,
  version: 18,
  sctVersion: 1,
};

const API = {
  userActivity: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/activity`;
    },
    mockUrl: () => {
      return `${window.SCT_MOCK_DATA_URL}/userActivity`;
    },
    useMockUrl: false
  },
  userPeople: {
    url: (slugs) => {
      return slugs.id ? `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers/${slugs.id}` : `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers`;
    },
    mockUrl: (slugs) => {
      return slugs ? `${window.SCT_MOCK_DATA_URL}/userPeople/${slugs.id}` : `${window.SCT_MOCK_DATA_URL}/userPeople`;
    },
    useMockUrl: false
  },
  userProfile: {
    url: `${window.sctApiUrl}api/v${api.sctVersion}/profile`,
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userProfile`,
    useMockUrl: false
  },
  userDebtor: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userDebtor`,
    useMockUrl: false
  },
  fareForecaster: {
    url: `${window.apiUrl}api/fareforecaster`,
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/fareforecaster`,
    useMockUrl: false
  },
  costCentres: {
    url: `${window.apiUrl}api/CostCentres`,
    mockUrl: `${window.MOCK_DATA_URL}/CostCentres`,
    useMockUrl: false
  },
  department: {
    url: `${window.apiUrl}api/Department`,
    mockUrl: `${window.MOCK_DATA_URL}/departments`,
    useMockUrl: false
  },
  departmentCode: {
    url: `${window.apiUrl}api/Department/departmentCode`,
    mockUrl: `${window.MOCK_DATA_URL}/departmentCode`,
    useMockUrl: false
  },
  settings: {
    url: `${window.apiUrl}api/Setting`,
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/Settings`,
    useMockUrl: false
  },
  travel: {
    url: `${window.apiUrl}api/Travel/search`,
    mockUrl: `${window.MOCK_DATA_URL}/Travel`,
    useMockUrl: false
  },
  travelDetail: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/details`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/TravelDetail`,
    useMockUrl: false
  },
  travelFareRules: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/fareclasses/${slugs.fareId}/farerules`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/FareRules`,
    useMockUrl: false
  },
  travelSeatMap: {
    url: (slugs) => {
      return `${window.apiUrl}api/SeatMap/search`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/SeatMap`,
    useMockUrl: false
  },
  flightInformation: {
    url: (slugs) => {
      return `${window.apiUrl}api/FlightInformation/search`;
    },
    mockUrl: `${window.TRAVEL_MOCK_DATA_URL}/FlightInformation`,
    useMockUrl: false
  },
  debtorSearch: {
    url: (slugs) => {
      return `${window.apiUrl}api/DebtorSearch`;
    },
    mockUrl: `${window.MOCK_DATA_URL}/DebtorSearch`,
    useMockUrl: false
  },
  locations: {
    url: (slugs) => {
      return `${window.apiUrl}api/location/poi`;
    },
    mockUrl: `${window.MOCK_DATA_URL}/location/poi`,
    useMockUrl: false
  },
  userInfo: {
    url: (slugs) => {
      return `${window.apiUrl}api/UserInfo`;
    },
    mockUrl: `${window.MOCK_DATA_URL}/UserInfo`,
    useMockUrl: false
  },
  userInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
  userRegister: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/profile/register`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
  forgotPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword?email=${encodeURIComponent(slugs.email)}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
  resetPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword/${slugs.token}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
  completeInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites/${slugs.token}/complete`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
  userContact: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/support/getintouch?message=${encodeURIComponent(slugs.message)}`;
    },
    mockUrl: `${window.SCT_MOCK_DATA_URL}/userInvite`,
    useMockUrl: false
  },
};

const version = {
  number: window.lbVersion
};

const analytics = {
  enabled: window.ANALYTICS_ENABLED,
  trackingCode: window.ANALYTICS_CODE,
};

const appInsights = {
  enabled: window.APPINSIGHTS_ENABLED,
  key: window.APPINSIGHTS_CODE,
};

const client = {
  id: window.CLIENT_ID,
  secret: window.CLIENT_SECRET
};

const MOCK_DATA = {
  active: window.MOCK_DATA,
  cars: `${window.MOCK_DATA_URL}/cars`,
  carDetails: `${window.MOCK_DATA_URL}/carDetails`,
  supplierLocations: `${window.MOCK_DATA_URL}/supplierLocations`,
  hotels: `${window.HOTEL_MOCK_DATA_URL}/hotels`,
  hotelsPartial: `${window.HOTEL_MOCK_DATA_URL}/hotelsPartial`,
  rail: `${window.MOCK_DATA_URL}/Rail`
};

const MVC = window.MVC;

const DISABLE_SEATMAPS = window.DISABLE_SEATMAPS;
const FARE_FORECASTER_ENABLED = window.FareForecasterEnabled;
const TICKETS_ON_HOLD_ENABLED = window.TicketsOnHoldEnabled;
const HOTEL_REVIEWS_ENABLED = window.HotelReviewsEnabled;
const THE_VIBE_ENABLED = window.TheVibeEnabled;
const RECENT_SEARCHES_ENABLED = window.RecentSearchesEnabled;
const PREFERRED_FLAG_ENABLED = window.PreferredFlagEnabled;
const ENABLE_ADD_TO_ITINERARY = window.EnableAddToItinerary;
const APP_CUES_ENABLED = window.AppCuesEnabled;
const MOBILE_SPLASH_SCREEN_ENABLED = window.MobileSplashScreenEnabled;

export default {
  APP_NAME: window.APP_NAME,
  analytics: analytics,
  appInsights: appInsights,
  version: version,
  momentFormat: momentFormat,
  message: message,
  APP_URL: window.APP_URL,
  api: api,
  API: API,
  client: client,
  MOCK_DATA: MOCK_DATA,
  MVC: MVC,
  DISABLE_SEATMAPS,
  RECENT_SEARCHES_ENABLED,
  FARE_FORECASTER_ENABLED,
  TICKETS_ON_HOLD_ENABLED,
  HOTEL_REVIEWS_ENABLED,
  THE_VIBE_ENABLED,
  PREFERRED_FLAG_ENABLED,
  ENABLE_ADD_TO_ITINERARY,
  APP_CUES_ENABLED,
  MOBILE_SPLASH_SCREEN_ENABLED
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js